module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0106-small-f87c3e2c472565c2758aaa7dbdeabc00.png";